webpackJsonp([1],{

/***/ "+3Hi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+k2G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



__webpack_require__("vRNc");

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ObjectList',
  props: ['objects', 'activeObject'],
  data: function data() {
    return {
      map: null,
      height: null,
      width: null,
      zoom: null,
      sort: 'number'
    };
  },

  watch: {
    activeObject: function activeObject() {
      if (!this.$refs.activeObject || !this.$refs.activeObject.length) {
        return;
      }

      this.$refs.activeObject[0].scrollIntoViewIfNeeded();
    }
  },
  created: function created() {},

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    sorted: function sorted() {
      return [].concat(this.objects).sort(function (a, b) {
        var an = parseInt(a.number, 10);
        var bn = parseInt(b.number, 10);

        if (an > bn) return 1;else if (an < bn) return -1;
        return 0;
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    objectsFiltered: 'getObjects'
  })),
  mounted: function mounted() {},

  methods: {
    rowActive: function rowActive(row) {
      return this.activeObject ? row.id === this.activeObject.id : false;
    },
    onRowClick: function onRowClick(row) {
      this.$emit('rowclick', row);
    },
    onRowMouseEnter: function onRowMouseEnter(row) {
      this.$emit('rowmouseenter', row);
    },
    onRowMouseLeave: function onRowMouseLeave(row) {
      this.$emit('rowmouseleave', row);
    }
  },
  components: {}
});

/***/ }),

/***/ "/ETF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Spinner',
  props: [],
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "/lkE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.object)?_c('div',{staticClass:"cw-object-popup",style:({ top: _vm.y, left: _vm.x})},[_c('div',{staticClass:"object-info"},[_c('h1',{staticClass:"object-title"},[_vm._v(_vm._s(_vm.object.number))]),_vm._v(" "),_c('table',{staticClass:"cw-object-popup-table object-info-table"},[_c('tr',[_c('th',[_vm._v("Antal rum")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.object.data['rooms']))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Storlek")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.object.data['living_area'])+" m"),_c('sup',[_vm._v("2")])])]),_vm._v(" "),(_vm.object.data['floor_number'])?_c('tr',[_c('th',[_vm._v("Våning")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.object.data['floor_number']))])]):_vm._e(),_vm._v(" "),(_vm.object.data['price'])?_c('tr',[_c('th',[_vm._v("Pris")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.object.data['price'].formatted))])]):_vm._e(),_vm._v(" "),(_vm.object.data['monthly_fee'])?_c('tr',[_c('th',[_vm._v("Avgift")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.object.data['monthly_fee'].formatted))])]):_vm._e(),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Status")]),_vm._v(" "),_c('td',[_c('span',{staticClass:"status-",class:'status-'+_vm.object.status},[_vm._v(_vm._s(_vm.object.status_name))])])])])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0lyA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MapRegion',
  props: ['region', 'zoom', 'active', 'lit', 'map'],
  data: function data() {
    return {};
  },
  created: function created() {},

  computed: {
    isDisabled: function isDisabled() {
      if (!this.region.object) {
        return false;
      }
      var object = this.$store.getters.getObject(+this.region.object.id);
      return object.disabled;
    },
    isLit: function isLit() {
      if (!this.region.object) {
        return false;
      }
      var object = this.$store.getters.getObject(+this.region.object.id);
      return object.lit;
    },
    statusClass: function statusClass() {
      if (this.map.type === 'Objects') {
        return this.region.object ? 'status-' + this.region.object.status : '';
      } else if (this.map.type === 'Maps') {
        return '';
      }
    },
    pathString: function pathString() {
      var _this = this;

      var area = this.region;
      var points = area.coords;

      if (!points.length) {
        return '';
      }

      var first = points[0];
      var last = points[points.length - 1];

      var path = 'M' + first[0] * this.zoom + ',' + first[1] * this.zoom;

      points.forEach(function (point) {
        path += 'L' + point[0] * _this.zoom + ',' + point[1] * _this.zoom;
      });

      path += 'M' + first[0] * this.zoom + ',' + first[1] * this.zoom + 'L' + last[0] * this.zoom + ',' + last[1] * this.zoom;

      this.path = path + 'Z';

      return path + 'Z';
    }
  },
  methods: {
    onClick: function onClick() {
      this.$emit('click');
    },
    onMouseMove: function onMouseMove(e) {
      this.$emit('mousemove', this.region, e);
    },
    onMouseLeave: function onMouseLeave(e) {
      this.$emit('mouseleave', this.region, e);
    }
  }
});

/***/ }),

/***/ "1PIj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3Ck+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ObjectMap_vue__ = __webpack_require__("GOts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52fc9a81_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ObjectMap_vue__ = __webpack_require__("e5AM");
function injectStyle (ssrContext) {
  __webpack_require__("+3Hi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ObjectMap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52fc9a81_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ObjectMap_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3GDu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_vue__ = __webpack_require__("fGNU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05e83858_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__ = __webpack_require__("4S7S");
function injectStyle (ssrContext) {
  __webpack_require__("fNXn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-05e83858"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05e83858_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4S7S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cw-map"},[_c('div',{staticClass:"cw-map-wrap"},[(!_vm.sunstudyView)?_c('img',{staticClass:"cw-map-image",attrs:{"src":_vm.imageSrc,"alt":"Map"}}):_vm._e(),_vm._v(" "),(_vm.sunstudyView)?_c('div',{staticClass:"cw-map-image cw-map-sunstudy"},_vm._l((_vm.slides),function(slide){return _c('div',{staticClass:"cw-map-sunstudy-slide",class:{'is-active':slide.active}},[_c('img',{attrs:{"src":slide.src,"srcset":slide.srcset}})])})):_vm._e(),_vm._v(" "),_c('svg',{staticClass:"cw-map-svg"},_vm._l((_vm.visibleRegions),function(region){return (_vm.regionVisible(region))?_c('map-region',{key:region.id,attrs:{"region":region,"zoom":_vm.zoom,"map":_vm.map,"active":_vm.regionActive(region),"lit":_vm.isLit},on:{"click":function($event){_vm.onRegionClick(region)},"mousemove":_vm.onRegionMouseEnter,"mouseleave":_vm.onRegionMouseLeave}}):_vm._e()}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6V2i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cw-map-filter",class:{'is-visible': _vm.visible}},[_c('div',{staticClass:"cw-map-filter-inner"},[_c('div',{staticClass:"cw-map-filter-rooms"},_vm._l((_vm.$store.state.roomOptions),function(room){return _c('label',{staticClass:"checkbox"},[_c('input',{attrs:{"type":"checkbox","name":"","id":'room'+room,"checked":""},on:{"change":function($event){_vm.toggleRoom(room)}}}),_vm._v(" "),_vm._v("\n        "+_vm._s(room)+" rok\n        "),_c('span',{staticClass:"check"})])})),_vm._v(" "),_c('div',{staticClass:"cw-map-filter-custom"},_vm._l((_vm.availableLighters),function(lighter){return _c('label',{staticClass:"checkbox"},[_c('input',{attrs:{"type":"checkbox","name":lighter.filter.key,"id":lighter.filter.key},domProps:{"checked":lighter.filter.key === _vm.activeLighter},on:{"change":function($event){_vm.onLighterToggle(lighter.filter.key)}}}),_vm._v(" "),_c('span',{staticClass:"check"}),_vm._v("\n        "+_vm._s(lighter.filter.label)+"\n      ")])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9jqn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ObjectList__ = __webpack_require__("x8l5");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ObjectDetail',
  props: ['widget'],
  data: function data() {
    return {
      object: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    allObjects: 'getObjects'
  })),
  watch: {
    '$route.params.objectId': function $routeParamsObjectId(to, from) {
      this.load();
    }
  },
  created: function created() {
    this.load();
  },
  mounted: function mounted() {},

  methods: {
    load: function load() {
      var id = this.$route.params.objectId;
      this.object = this.$store.getters.getObject(+id);
      if (!this.object) {
        throw new Error('objekt hittas inte');
      }
    },
    onRowClick: function onRowClick(object) {}
  },
  components: {
    'cw-object-list': __WEBPACK_IMPORTED_MODULE_2__components_ObjectList__["a" /* default */]
  }
});

/***/ }),

/***/ "B1f0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('h1',{staticClass:"loader"},[_c('div',{staticClass:"spinner",attrs:{"title":"2"}},[_c('svg',{staticStyle:{"enable-background":"new 0 0 50 50"},attrs:{"version":"1.1","id":"loader-1","xmlns":"http://www.w3.org/2000/svg","x":"0px","y":"0px","width":"40px","height":"40px","viewBox":"0 0 50 50","xml:space":"preserve"}},[_c('path',{attrs:{"fill":"#000","d":"M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z","transform":"rotate(160 25 25)"}},[_c('animateTransform',{attrs:{"attributeType":"xml","attributeName":"transform","type":"rotate","from":"0 25 25","to":"360 25 25","dur":"0.6s","repeatCount":"indefinite"}})],1)])])]):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('div',[_c('router-view',{attrs:{"widget":_vm.widget}})],1):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('div',[_c('link',{attrs:{"rel":"stylesheet","type":"text/css","href":_vm.templateCssUrl}})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ce7e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DIIa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Spinner_vue__ = __webpack_require__("/ETF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cc05569_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Spinner_vue__ = __webpack_require__("Fx21");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Spinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cc05569_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Spinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DP7s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");




__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);
var state = {
  size: { width: 0, height: 0 },
  roomOptions: [],
  objects: [],
  availableFilters: {},
  availableLighters: {},
  activeFilters: [],
  activeLighter: null,
  filters: { 'rooms': [] },
  lit: false
};

function filterByRooms(list, rooms) {
  if (!rooms.length) {
    return list;
  }

  return list.map(function (obj) {
    obj.disabled = rooms.indexOf(obj.data['rooms']) === -1;
    return obj;
  });
}

function applyObjectFilter(obj, field, operator, value) {
  var objValue = void 0;

  if (field === 'status') {
    objValue = obj.status;
  } else {
    objValue = obj.data[field];
  }

  if (operator === '=') {
    return objValue === value;
  } else if (operator === '<') {
    return objValue < value;
  } else if (operator === '>') {
    return objValue > value;
  }

  return false;
}

function applyObjectLighter(obj, field, operator, value) {
  var objValue = void 0;

  if (field === 'status') {
    objValue = obj.status;
  } else {
    objValue = obj.data[field];
  }

  if (operator === '=') {
    return objValue === value;
  } else if (operator === '<') {
    return objValue < value;
  } else if (operator === '>') {
    return objValue > value;
  }

  return false;
}

function applyLighters(objects) {
  if (!state.activeLighter) {
    return objects.map(function (obj) {
      obj.lit = false;
      return obj;
    });
  }

  // const lighter = state.availableLighters[state.activeLighter]

  var lighter = state.availableLighters.find(function (l) {
    return l.filter.key === state.activeLighter;
  });

  if (!lighter) return;

  return objects.map(function (obj) {
    if (!lighter.filter.field) {
      obj.lit = true;
    } else {
      obj.lit = applyObjectLighter(obj, lighter.filter.field, lighter.filter.operator, lighter.filter.value);
    }
    return obj;
  });
}

function applyFilters(objects) {
  var activeFilters = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(state.availableFilters).map(function (k) {
    return state.availableFilters[k];
  }).filter(function (f) {
    return f.active;
  });

  if (!activeFilters.length) {
    return objects;
  }

  return objects.map(function (obj) {
    if (obj.disabled) {
      return obj;
    }
    for (var i = 0; i < activeFilters.length; i++) {
      var filter = activeFilters[i];

      if (!applyObjectFilter(obj, filter.filter.field, filter.filter.operator, filter.filter.value)) {
        obj.disabled = true;
      }
    }
    return obj;
  });
  /* let c = objects.filter((obj) => {
    for (let i = 0; i < activeFilters.length; i++) {
      const filter = activeFilters[i]
       if (!applyObjectFilter(obj, filter.field, filter.operator, filter.value)) {
        return false
      }
    }
    return true
  })
  return c */
}

var getters = {
  getObjects: function getObjects() {
    return applyLighters(applyFilters(filterByRooms(state.objects, state.filters.rooms)));
  },
  getObject: function getObject() {
    var obj = applyLighters(applyFilters(filterByRooms(state.objects, state.filters.rooms)));

    return function (id) {
      return obj.find(function (obj) {
        return obj.id === id;
      });
    };
  },
  getAvailableFilters: function getAvailableFilters() {
    return state.availableFilters;
  },
  getAvailableLighters: function getAvailableLighters() {
    return state.availableLighters;
  },
  getActiveLighter: function getActiveLighter() {
    return state.activeLighter;
  },
  getSize: function getSize() {},
  isLit: function isLit() {
    return state.lit;
  }
};

var mutations = {
  setMainSize: function setMainSize(state, sizes) {
    state.size = {
      width: sizes[0],
      height: sizes[1]
    };
  },
  toggleShowAll: function toggleShowAll(state, toggle) {
    state.lit = !state.lit;
  },
  toggleFilter: function toggleFilter(state, filter) {
    state.availableFilters[filter].active = !state.availableFilters[filter].active;
  },
  setAvailableLighters: function setAvailableLighters(state, lighters) {
    state.availableLighters = lighters;
  },
  toggleLighter: function toggleLighter(state, lighter) {
    if (state.activeLighter === lighter) {
      state.activeLighter = null;
    } else {
      state.activeLighter = lighter;
    }
  },
  setAvailableFilters: function setAvailableFilters(state, filters) {
    state.availableFilters = filters;
  },
  setObjects: function setObjects(state, objects) {
    state.objects = objects;
  },
  setRoomOptions: function setRoomOptions(state, opts) {
    state.roomOptions = opts;
    state.filters['rooms'] = [].concat(opts);
  },
  toggleRoom: function toggleRoom(state, room) {
    var idx = state.filters['rooms'].indexOf(room);

    if (idx > -1) {
      state.filters['rooms'].splice(idx, 1);
    } else {
      state.filters['rooms'].push(room);
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  state: state,
  getters: getters,
  mutations: mutations
}));

/***/ }),

/***/ "FhGN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Fx21":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner",attrs:{"title":"2"}},[_c('svg',{staticStyle:{"enable-background":"new 0 0 50 50"},attrs:{"version":"1.1","id":"loader-1","xmlns":"http://www.w3.org/2000/svg","x":"0px","y":"0px","width":"40px","height":"40px","viewBox":"0 0 50 50","xml:space":"preserve"}},[_c('path',{attrs:{"fill":"#000","d":"M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z","transform":"rotate(160 25 25)"}},[_c('animateTransform',{attrs:{"attributeType":"xml","attributeName":"transform","type":"rotate","from":"0 25 25","to":"360 25 25","dur":"0.6s","repeatCount":"indefinite"}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GGBK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"cw-sunstudy-controls"},[_c('h3',{staticClass:"sunstudy-heading"},[_vm._v("Solstudie")]),_vm._v(" "),_c('p',{staticClass:"sunstudy-text"},[_vm._v("Dra i reglaget för att välja tid på dygnet")]),_vm._v(" "),_c('div',{staticClass:"cw-sunstudy-controls-top"},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"c-time-label"},[_vm._v("kl")]),_vm._v(" "),_c('div',{staticClass:"sunstudy-time-cols"},[_vm._l((_vm.cols),function(col){return _c('div',{class:col.className,on:{"click":function($event){_vm.onHourClick(col)}}},[_vm._v(_vm._s(col.label))])}),_vm._v(" "),_c('div',{staticClass:"sunstudy-current-hour"},[_vm._v(_vm._s(_vm.currentHour))])],2),_vm._v(" "),_c('div',{staticClass:"c-view-buttons"},_vm._l((_vm.sunstudy.views.data),function(v){return _c('button',{staticClass:"btn",class:{'active': v.id === _vm.view.id},on:{"click":function($event){_vm.changeView(v)}}},[_vm._v(_vm._s(v.name)+"\n        ")])}))]),_vm._v(" "),_c('div',{staticClass:"cw-sunstudy-controls-bottom"},[_c('div',{staticClass:"cw-sunstudy-controls-slider"},[_c('div',{class:'fake-slider fake-slider-w-' + _vm.offsetLeft},[_c('div',{staticClass:"slider-rail"})]),_vm._v(" "),_c('vue-slider',{ref:"slider",staticClass:"cw-sunstudy-slider real-slider",attrs:{"minx":1,"max":_vm.view.image_count-1,"height":1,"real-time":true,"tooltip":false,"dot-width":30,"dot-height":8},model:{value:(_vm.currentFrame),callback:function ($$v) {_vm.currentFrame=$$v},expression:"currentFrame"}}),_vm._v(" "),_c('div',{class:'fake-slider fake-slider-w-' + _vm.offsetRight},[_c('div',{staticClass:"slider-rail"})])],1)]),_vm._v(" "),_c('div')])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-icon"},[_c('span',{staticClass:"icon icon-sun"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GOts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Map__ = __webpack_require__("3GDu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Partials_Spinner__ = __webpack_require__("DIIa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_MapFilter__ = __webpack_require__("b/Po");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ObjectList__ = __webpack_require__("x8l5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ObjectPopup__ = __webpack_require__("gtoI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Partials_SunstudyControls__ = __webpack_require__("WcBD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__functions__ = __webpack_require__("ljCr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__("NYxO");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Map',
  props: ['widget'],
  data: function data() {
    return {
      showFilter: false,
      loadedSunstudies: [],
      sunstudyLoading: null,
      sunstudyView: null,
      sunstudySlide: null,
      loading: true,
      mousePosition: null,
      activeObject: null,
      overviewActive: false,
      map: null,
      overviewMap: null,
      height: null,
      width: null,
      zoom: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    objects: function objects() {
      var _this = this;

      return this.objectsFiltered.filter(function (object) {
        return _this.map.regions.data.findIndex(function (region) {
          return region.object && region.object.id === object.id;
        }) > -1;
      });
    },
    overviewSize: function overviewSize() {
      return this.overviewActive ? 40 : 15;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapGetters */])({
    objectsFiltered: 'getObjects'
  })),
  watch: {
    '$route.params.id': function $routeParamsId(to, from) {
      this.init();
    },
    sunstudyView: function sunstudyView() {
      var _this2 = this;

      if (this.loadedSunstudies.indexOf(this.sunstudyView.id) > -1) {
        this.loading = false;
        return;
      }

      this.loading = true;

      this.preloadSunstudyView(this.sunstudyView).then(function (loadedView) {
        _this2.loadedSunstudies.push(loadedView.id);
        setTimeout(function () {
          _this2.loading = false;
        }, 500);
      });
    }
  },
  created: function created() {
    var _this3 = this;

    this.init();

    window.addEventListener('resize', function () {
      _this3.resize();
    });
  },
  mounted: function mounted() {
    var _this4 = this;

    this.$nextTick(function () {
      _this4.resize();
    });
  },

  methods: {
    init: function init() {
      var _this5 = this;

      var id = this.$route.params.id;
      this.map = this.widget.object_maps.data.find(function (m) {
        return m.id === +id;
      });
      if (!this.map) {
        this.navigate('');
      }

      this.loading = true;

      // this.parseObjects()

      this.overviewMap = this.widget.overview_maps.data[0];

      if (!this.widget.template_config) {
        throw new Error('no template config');
      }

      this.hideObjectList = this.widget.template_config.hide_object_list || false;
      this.externalLinks = this.widget.settings.external_links;
      this.externalLinkBase = this.widget.settings.external_link_base;

      if (this.map.sunstudy) {
        this.sunstudyView = this.map.sunstudy.views.data[0];
        this.sunstudySlide = this.sunstudyView.start_frame;
      } else {
        this.loading = false;
      }

      if (!this.map) {
        throw new Error('karta hittas inte');
      }

      this.$nextTick(function () {
        _this5.resize();
      });
    },
    toggleFilter: function toggleFilter() {
      this.showFilter = !this.showFilter;
    },
    goNext: function goNext() {
      var _this6 = this;

      var idx = this.widget.object_maps.data.findIndex(function (m) {
        return m.id === _this6.map.id;
      });
      var next = void 0;

      if (this.widget.object_maps.data.length > idx + 1) {
        next = this.widget.object_maps.data[idx + 1];
      } else {
        next = this.widget.object_maps.data[0];
      }

      this.navigate('map/' + next.id);
    },
    goPrev: function goPrev() {
      var _this7 = this;

      var idx = this.widget.object_maps.data.findIndex(function (m) {
        return m.id === _this7.map.id;
      });
      var next = void 0;

      if (idx > 0) {
        next = this.widget.object_maps.data[idx - 1];
      } else {
        next = this.widget.object_maps.data[this.widget.object_maps.data.length - 1];
      }

      this.navigate('map/' + next.id);
    },
    onSunstudySlide: function onSunstudySlide(slide) {
      this.sunstudySlide = slide;
    },
    onSunstudyViewChange: function onSunstudyViewChange(view) {
      this.sunstudyView = view;
    },
    onOverviewRegionClick: function onOverviewRegionClick(region) {
      this.navigate('map/' + region.entity_id);
    },
    onOverviewMouseover: function onOverviewMouseover() {
      var _this8 = this;

      this.overviewActive = true;
      this.$nextTick(function () {
        _this8.$refs.overview.resize();
      });
    },
    onOverviewMouseout: function onOverviewMouseout() {
      var _this9 = this;

      this.overviewActive = false;
      this.$nextTick(function () {
        _this9.$refs.overview.resize();
      });
    },
    preloadSunstudyView: function preloadSunstudyView(view) {
      var _this10 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var promises = [];
        _this10.sunstudyLoading = { total: view.image_count, finished: 0 };

        var _loop = function _loop(i) {
          var num = Object(__WEBPACK_IMPORTED_MODULE_8__functions__["a" /* pad */])('0000', i, true);
          var url = window.innerWidth > 640 ? '' + (view.base_url + '/' + num + '-1200.jpg') : '' + (view.base_url + '/' + num + '-640.jpg');

          promises.push(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (imgResolve, imgReject) {
            // eslint-disable-line
            var image = new Image();
            image.addEventListener('load', function () {
              _this10.sunstudyLoading['finished']++;
              imgResolve();
            }, false);
            image.addEventListener('error', function () {
              _this10.sunstudyLoading['finished']++;
              imgResolve();
            }, false);
            image.src = url;
          }));
        };

        for (var i = 0; i <= view.image_count - 1; i++) {
          _loop(i);
        }

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function (values) {
          resolve(view);
        });
      });
    },
    navigate: function navigate(url) {
      this.$router.push('/' + this.$route.params.template + '/' + this.$route.params.slug + '/' + url);
    },
    onRowClick: function onRowClick(row) {
      if (this.externalLinks) {
        if (row.data['url']) {
          window.top.location.href = '' + (this.externalLinkBase ? this.externalLinkBase : '') + row.data['url'];
        }
      } else {
        this.navigate('map/' + this.$route.params.id + '/object/' + row.id);
      }
    },
    onRowMouseEnter: function onRowMouseEnter(row) {
      this.activeObject = row;
    },
    onRowMouseLeave: function onRowMouseLeave(row) {
      this.activeObject = null;
    },
    resize: function resize() {
      var ratio = this.map.height / this.map.width;

      this.width = this.$el.clientWidth;
      this.height = this.width * ratio;

      this.zoom = this.width / this.map.width;

      this.$store.commit('setMainSize', [this.width, this.height]);
    },
    onRegionClick: function onRegionClick(region) {
      if (this.externalLinks) {
        if (region.object.data['url']) {
          window.top.location.href = '' + (this.externalLinkBase ? this.externalLinkBase : '') + region.object.data['url'];
        }
      } else {
        this.navigate('map/' + this.$route.params.id + '/object/' + region.object.id);
      }
    },
    onRegionMousemove: function onRegionMousemove(region, e) {
      this.mousePosition = { x: e.clientX, y: e.clientY };

      if (e.offsetX + 250 > this.width) {
        this.mousePosition.x = Math.max(0, this.mousePosition.x - 250);
      }

      if (e.offsetY + 300 > this.height) {
        this.mousePosition.y = Math.max(0, this.mousePosition.y - 300);
      }

      this.activeObject = region.object;
    },
    onRegionMouseLeave: function onRegionMouseLeave(region, e) {
      this.activeObject = null;
      this.mousePosition = null;
    }
  },
  components: {
    'cw-map': __WEBPACK_IMPORTED_MODULE_2__components_Map__["a" /* default */],
    'cw-spinner': __WEBPACK_IMPORTED_MODULE_3__components_Partials_Spinner__["a" /* default */],
    'cw-sunstudy-controls': __WEBPACK_IMPORTED_MODULE_7__components_Partials_SunstudyControls__["a" /* default */],
    'cw-filter': __WEBPACK_IMPORTED_MODULE_4__components_MapFilter__["a" /* default */],
    'cw-object-list': __WEBPACK_IMPORTED_MODULE_5__components_ObjectList__["a" /* default */],
    'cw-object-popup': __WEBPACK_IMPORTED_MODULE_6__components_ObjectPopup__["a" /* default */]
  }
});

/***/ }),

/***/ "Hsm9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Widget_vue__ = __webpack_require__("lame");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea797aaa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Widget_vue__ = __webpack_require__("B1f0");
function injectStyle (ssrContext) {
  __webpack_require__("nSOg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Widget_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea797aaa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Widget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LV39":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d68f3a6e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("cEGT");
function injectStyle (ssrContext) {
  __webpack_require__("d1xo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d68f3a6e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filter__ = __webpack_require__("DP7s");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__webpack_require__("2Jj2");
__webpack_require__("hKoQ").polyfill();
__webpack_require__("j9g7");
__webpack_require__("TNND");

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_4__filter__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),

/***/ "PRE3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ObjectDetail_vue__ = __webpack_require__("9jqn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2f05d30_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ObjectDetail_vue__ = __webpack_require__("pxDt");
function injectStyle (ssrContext) {
  __webpack_require__("LV39")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c2f05d30"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ObjectDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2f05d30_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ObjectDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Pi7R":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q93P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapRegion_vue__ = __webpack_require__("0lyA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00fd1371_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapRegion_vue__ = __webpack_require__("gJFj");
function injectStyle (ssrContext) {
  __webpack_require__("Pi7R")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-00fd1371"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapRegion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00fd1371_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapRegion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QBU0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(_vm._s(_vm.widget))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TNND":
/***/ (function(module, exports) {

/* eslint-disable semi, no-extend-native */

if (!Array.prototype.find) {
  Object.defineProperty(Array.prototype, 'find', {
    value: function value(predicate) {
      // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If IsCallable(predicate) is false, throw a TypeError exception.
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }

      // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
      var thisArg = arguments[1];

      // 5. Let k be 0.
      var k = 0;

      // 6. Repeat, while k < len
      while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return kValue.
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) {
          return kValue;
        }
        // e. Increase k by 1.
        k++;
      }

      // 7. Return undefined.
      return undefined;
    }
  });
}

// https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
if (!Array.prototype.findIndex) {
  Object.defineProperty(Array.prototype, 'findIndex', {
    value: function value(predicate) {
      // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If IsCallable(predicate) is false, throw a TypeError exception.
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }

      // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
      var thisArg = arguments[1];

      // 5. Let k be 0.
      var k = 0;

      // 6. Repeat, while k < len
      while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return k.
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) {
          return k;
        }
        // e. Increase k by 1.
        k++;
      }

      // 7. Return -1.
      return -1;
    }
  });
}

/***/ }),

/***/ "VgoI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MapFilter',
  props: ['visible'],
  data: function data() {
    return {
      showAll: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    objects: 'getObjects',
    activeLighter: 'getActiveLighter',
    availableFilters: 'getAvailableFilters',
    availableLighters: 'getAvailableLighters'
  })),
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    onLighterToggle: function onLighterToggle(id) {
      this.$store.commit('toggleLighter', id);
    },
    onFilterChange: function onFilterChange(id) {
      this.$store.commit('toggleFilter', id);
    },
    toggleFilter: function toggleFilter() {
      this.visible = !this.visible;
    },
    toggleRoom: function toggleRoom(room) {
      this.$store.commit('toggleRoom', room);
    },
    toggleShowAll: function toggleShowAll() {
      this.$store.commit('toggleShowAll', this.showAll);
    }
  },
  components: {}
});

/***/ }),

/***/ "Vidm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[(!_vm.data)?_c('h1',[_vm._v("Laddar...")]):_vm._e(),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.data))]),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WcBD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SunstudyControls_vue__ = __webpack_require__("r8F1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b96eb20_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SunstudyControls_vue__ = __webpack_require__("GGBK");
function injectStyle (ssrContext) {
  __webpack_require__("Ce7e")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SunstudyControls_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b96eb20_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SunstudyControls_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Y59b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cw-object-table-wrap"},[_c('div',{staticClass:"cw-object-table"},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"cw-object-table-body"},_vm._l((_vm.sorted),function(row){return _c('div',{ref:_vm.rowActive(row) ? 'activeObject' : null,refInFor:true,staticClass:"list-row",class:[{active: _vm.rowActive(row)}, 'status-'+row.status],on:{"click":function($event){_vm.onRowClick(row)},"mouseenter":function($event){_vm.onRowMouseEnter(row)},"mouseleave":function($event){_vm.onRowMouseLeave(row)}}},[_c('div',{staticClass:"col col-number nowrap"},[_vm._v(_vm._s(row.number))]),_vm._v(" "),(row.data['rooms'])?_c('div',{staticClass:"col col-rooms nowrap"},[_vm._v(_vm._s(row.data['rooms'])+" rok")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col col-area nowrap"},[_vm._v(_vm._s(row.data['living_area'])+" "),_vm._m(1,true,false)]),_vm._v(" "),_c('div',{staticClass:"col col-floor nowrap"},[_vm._v(_vm._s(row.data['floor_number']))]),_vm._v(" "),_c('div',{staticClass:"col col-price nowrap"},[_vm._v(_vm._s(row.data['price'] ? row.data['price']['formatted'] : '-'))]),_vm._v(" "),_c('div',{staticClass:"col col-status nowrap"},[_c('span',{staticClass:"status",class:'status-' + row.status},[_vm._v(_vm._s(row.status_name))])])])}))])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cw-object-table-head"},[_c('div',{staticClass:"list-row"},[_c('div',{staticClass:"col col-number"},[_vm._v("Lägenhetsnr")]),_vm._v(" "),_c('div',{staticClass:"col col-rooms"},[_vm._v("Antal rum")]),_vm._v(" "),_c('div',{staticClass:"col col-area"},[_vm._v("Storlek")]),_vm._v(" "),_c('div',{staticClass:"col col-floor"},[_vm._v("Våning")]),_vm._v(" "),_c('div',{staticClass:"col col-price"},[_vm._v("Pris")]),_vm._v(" "),_c('div',{staticClass:"col col-status"},[_vm._v("Status")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"hidden-xs-down"},[_vm._v("m"),_c('sup',[_vm._v("2")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Widget__ = __webpack_require__("Hsm9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Start__ = __webpack_require__("zgV5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ObjectMap__ = __webpack_require__("3Ck+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Overview__ = __webpack_require__("ekZu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ObjectDetail__ = __webpack_require__("PRE3");








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/:template/:slug',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Widget__["a" /* default */],
    children: [{
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_3__components_Start__["a" /* default */]
    }, {
      path: 'overview',
      component: __WEBPACK_IMPORTED_MODULE_5__components_Overview__["a" /* default */]
    }, {
      path: 'map/:id',
      component: __WEBPACK_IMPORTED_MODULE_4__components_ObjectMap__["a" /* default */],
      children: [{
        path: 'object/:objectId',
        component: __WEBPACK_IMPORTED_MODULE_6__components_ObjectDetail__["a" /* default */]
      }]
    }]
  }]
}));

/***/ }),

/***/ "b/Po":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapFilter_vue__ = __webpack_require__("VgoI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54c3aaca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapFilter_vue__ = __webpack_require__("6V2i");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54c3aaca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapFilter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bZlt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

var API_URL = 'http://carbonwhite-api.test/api/public/widgets';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Widget',
  data: function data() {
    return {
      data: null,
      msg: 'Welcome to Your Vue.js App'
    };
  },
  created: function created() {
    var slug = this.$route.params.slug;
    this.load(slug);
  },

  methods: {
    load: function load(slug) {
      var _this = this;

      fetch(API_URL + '/' + slug).then(function (response) {
        return response.json();
      }).then(function (json) {
        /*
        if (responseJson.sunstudies) {
          this.preloadSunstudies(responseJson.sunstudies.data).then(done => {
            this.setState({
              data: responseJson
            })
          })
        }
        */

        _this.data = json;
      });
    }
  }
});

/***/ }),

/***/ "cEGT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "d1xo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dZYA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import {mapGetters} from 'vuex'

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ObjectPopup',
  props: ['object', 'position'],
  data: function data() {
    return {};
  },

  computed: {
    x: function x() {
      return this.position.x + 20 + 'px';
    },
    y: function y() {
      return this.position.y + 20 + 'px';
    }
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {},
  components: {}
});

/***/ }),

/***/ "e5AM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap",class:{'is-loading': _vm.loading}},[_c('div',{staticClass:"col-map"},[_c('div',{staticStyle:{"position":"relative","overflow":"hidden"}},[(_vm.map)?_c('cw-map',{ref:"mainMap",attrs:{"map":_vm.map,"active-entity":_vm.activeObject,"sunstudyView":_vm.sunstudyView,"sunstudySlide":_vm.sunstudySlide},on:{"regionclick":_vm.onRegionClick,"regionmousemove":_vm.onRegionMousemove,"regionmouseleave":_vm.onRegionMouseLeave}}):_vm._e(),_vm._v(" "),_c('cw-filter',{attrs:{"visible":_vm.showFilter}}),_vm._v(" "),_c('button',{staticClass:"btn cw-map-filter-toggle",attrs:{"type":"button"},on:{"click":_vm.toggleFilter}},[(!_vm.showFilter)?_c('span',[_vm._v("Filtrera val")]):_vm._e(),_vm._v(" "),(_vm.showFilter)?_c('span',[_vm._v("Minimera")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"map-loader",class:{'is-visible': _vm.loading}},[(_vm.sunstudyLoading)?_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:({width: (_vm.sunstudyLoading.finished / _vm.sunstudyLoading.total)*100 + '%' })})]):_vm._e()]),_vm._v(" "),(_vm.mousePosition)?_c('cw-object-popup',{attrs:{"object":_vm.activeObject,"position":_vm.mousePosition}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"map-overview",on:{"mouseover":_vm.onOverviewMouseover,"mouseout":_vm.onOverviewMouseout}},[(_vm.overviewMap)?_c('cw-map',{ref:"overview",style:({width: _vm.overviewSize + '%', zIndex: _vm.overviewActive ? 1000 : 10}),attrs:{"map":_vm.overviewMap,"active-entity":_vm.map},on:{"regionclick":_vm.onOverviewRegionClick}}):_vm._e()],1),_vm._v(" "),_c('nav',{staticClass:"cw-map-nav"},[_c('button',{staticClass:"cw-map-nav-prev",on:{"click":function($event){_vm.goPrev()}}},[_c('span',{staticClass:"icon icon-arrow-left"})]),_vm._v(" "),_c('button',{staticClass:"cw-map-nav-next",on:{"click":function($event){_vm.goNext()}}},[_c('span',{staticClass:"icon icon-arrow-right"})])])],1),_vm._v(" "),(_vm.map.sunstudy)?_c('cw-sunstudy-controls',{staticClass:"col-sunstudy-controls",attrs:{"sunstudy":_vm.map.sunstudy,"view":_vm.sunstudyView,"slide":_vm.sunstudySlide},on:{"view":_vm.onSunstudyViewChange,"slide":_vm.onSunstudySlide}}):_vm._e(),_vm._v(" "),_c('router-view',{attrs:{"map":_vm.map}})],1),_vm._v(" "),(!_vm.hideObjectList)?_c('div',{staticClass:"col-list"},[_c('cw-object-list',{attrs:{"objects":_vm.objects,"active-object":_vm.activeObject},on:{"rowclick":_vm.onRowClick,"rowmouseenter":_vm.onRowMouseEnter,"rowmouseleave":_vm.onRowMouseLeave}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ekZu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overview_vue__ = __webpack_require__("bZlt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7153860_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overview_vue__ = __webpack_require__("Vidm");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7153860_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fGNU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Partials_MapRegion__ = __webpack_require__("Q93P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function pad(pad, str, padLeft) {
  if (typeof str === 'undefined') {
    return pad;
  }
  if (padLeft) {
    return (pad + str).slice(-pad.length);
  } else {
    return (str + pad).substring(0, pad.length);
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Map',
  props: ['map', 'activeEntity', 'sunstudySlide', 'sunstudyView'],
  data: function data() {
    return {
      height: null,
      width: null
      // zoom: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    slides: function slides() {
      var slides = [];
      for (var i = 0; i <= this.sunstudyView.image_count - 1; i++) {
        var num = pad('0000', i, true);
        slides.push({
          active: this.sunstudySlide === i,
          src: this.sunstudyView.base_url + '/' + num + '-640.jpg',
          srcset: this.sunstudyView.base_url + '/' + num + '-640.jpg 640w, ' + this.sunstudyView.base_url + '/' + num + '-1200.jpg 1200w'
        });
      }
      return slides;
    },
    imageSrc: function imageSrc() {
      return this.map.src;
    },
    zoom: function zoom() {
      return this.width / this.map.width;
    },
    activeRegion: function activeRegion() {
      var _this = this;

      if (!this.activeEntity) {
        return null;
      }

      return this.visibleRegions.find(function (r) {
        return r.entity_id === _this.activeEntity.id;
      });
    },
    visibleRegions: function visibleRegions() {
      var _this2 = this;

      if (this.map.type === 'Objects') {
        return this.map.regions.data.filter(function (region) {
          if (!region.object) {
            return false;
          }
          return _this2.objectsFiltered.find(function (obj) {
            return obj.id === region.object.id;
          });
        });
      }

      return this.map.regions.data;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
    objectsFiltered: 'getObjects',
    isLit: 'isLit'
  })),
  created: function created() {
    if (!this.map) {
      throw new Error('karta hittas inte');
    }

    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  mounted: function mounted() {
    this.resize();
  },

  methods: {
    handleResize: function handleResize() {
      this.resize();
    },
    regionVisible: function regionVisible(region) {
      if (this.map.type === 'Objects') {
        return this.objectsFiltered.find(function (obj) {
          return obj.id === region.object.id;
        });
      }
      return true;
    },
    regionLit: function regionLit(region) {
      if (this.map.type === 'Objects') {
        var obj = this.objectsFiltered.find(function (obj) {
          return obj.id === region.object.id;
        });
        return obj.lit;
      }
      return false;
    },
    regionActive: function regionActive(region) {
      if (!this.activeEntity) {
        return false;
      }
      return this.activeEntity.id === region.entity_id;
    },
    resize: function resize() {
      var ratio = this.map.height / this.map.width;

      this.width = this.$el.clientWidth;
      this.height = this.width * ratio;

      // this.zoom = Math.min(1, this.width / this.map.width)
      // this.zoom = this.width / this.map.width
    },
    onRegionClick: function onRegionClick(region) {
      this.$emit('regionclick', region);
    },
    onRegionMouseEnter: function onRegionMouseEnter(region, e) {
      this.$emit('regionmousemove', region, e);
    },
    onRegionMouseLeave: function onRegionMouseLeave(region, e) {
      this.$emit('regionmouseleave', region, e);
    }
  },
  components: {
    'map-region': __WEBPACK_IMPORTED_MODULE_1__components_Partials_MapRegion__["a" /* default */]
  }
});

/***/ }),

/***/ "fNXn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gJFj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.region && _vm.zoom)?_c('path',{class:[{'is-active': _vm.active, 'is-lit': _vm.isLit, 'is-disabled' : _vm.isDisabled }, _vm.statusClass],attrs:{"d":_vm.pathString,"stroke-width":"0","href":"#"},on:{"click":_vm.onClick,"mouseover":_vm.onMouseMove,"touchstart":_vm.onMouseMove,"touchend":_vm.onMouseLeave,"mouseout":_vm.onMouseLeave}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gtoI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ObjectPopup_vue__ = __webpack_require__("dZYA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_983a7736_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ObjectPopup_vue__ = __webpack_require__("/lkE");
function injectStyle (ssrContext) {
  __webpack_require__("FhGN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ObjectPopup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_983a7736_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ObjectPopup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hcza":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Start',
  props: ['widget'],
  data: function data() {
    return {};
  },
  created: function created() {
    var map = this.widget.object_maps.data[0];
    if (map) {
      this.$router.push(this.widget.slug + '/map/' + map.id);
    }
  },

  methods: {}
});

/***/ }),

/***/ "lame":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var API_URL =  true ? 'https://api.webservices.carbonwhite.se/api/public/widgets' : 'http://carbonwhite-api.test/api/public/widgets';

var CSS_URL =  true ? '//v3.widgets.carbonwhite.se/css/templates/' : '//carbonwhite-widgets-vue.test/css/templates/';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Widget',
  data: function data() {
    return {
      templateCssUrl: '' + CSS_URL + this.$route.params.template + '.css',
      loading: true,
      widget: null
    };
  },
  created: function created() {
    this.init();
  },

  watch: {
    '$route.params.slug': function $routeParamsSlug(to, from) {
      this.init();
    }
  },
  methods: {
    init: function init() {
      var slug = this.$route.params.slug;
      this.load(slug);
    },
    transformData: function transformData(json) {
      var rooms = json.objects.data.map(function (obj) {
        return obj.data['rooms'];
      }).filter(function (r) {
        return r;
      }).sort();
      this.$store.commit('setRoomOptions', [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(rooms))));
      this.$store.commit('setObjects', json.objects.data);
      this.$store.commit('setAvailableFilters', json.filters ? json.filters.data : []);
      this.$store.commit('setAvailableLighters', json.filters ? json.filters.data : []);
      this.loading = false;
      return json;
    },
    load: function load(slug) {
      var _this = this;

      fetch(API_URL + '/' + slug).then(function (response) {
        return response.json();
      }).then(function (json) {
        _this.widget = _this.transformData(json);
        /*
        if (responseJson.sunstudies) {
          this.preloadSunstudies(responseJson.sunstudies.data).then(done => {
            this.setState({
              data: responseJson
            })
          })
        }
        */
      });
    }
  }
});

/***/ }),

/***/ "ljCr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pad;
function pad(pad, str, padLeft) {
  if (typeof str === 'undefined') {
    return pad;
  }
  if (padLeft) {
    return (pad + str).slice(-pad.length);
  } else {
    return (str + pad).substring(0, pad.length);
  }
}

/***/ }),

/***/ "nSOg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pxDt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"object-detail"},[_c('div',{staticClass:"object-detail-wrap"},[_c('div',{staticClass:"object-plan"},[_c('img',{attrs:{"src":_vm.object.resource_urls.plan}})]),_vm._v(" "),_c('div',{staticClass:"object-info"},[_c('h1',{staticClass:"object-title"},[_vm._v(_vm._s(_vm.object.number))]),_vm._v(" "),_c('table',{staticClass:"object-info-table detail-object-info-table"},[(_vm.object.data['floor_number'])?_c('tr',[_c('th',[_vm._v("Våning")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.object.data['floor_number']))])]):_vm._e(),_vm._v(" "),(_vm.object.data['rooms'])?_c('tr',[_c('th',[_vm._v("Antal rum")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.object.data['rooms']))])]):_vm._e(),_vm._v(" "),(_vm.object.data['living_area'])?_c('tr',[_c('th',[_vm._v("Storlek")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.object.data['living_area'])+" m"),_c('sup',[_vm._v("2")])])]):_vm._e(),_vm._v(" "),(_vm.object.data['price'])?_c('tr',[_c('th',[_vm._v("Pris")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.object.data['price'].formatted))])]):_vm._e(),_vm._v(" "),(_vm.object.data['monthly_fee'])?_c('tr',[_c('th',[_vm._v("Avgift")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.object.data['monthly_fee'].formatted))])]):_vm._e(),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Status")]),_vm._v(" "),_c('td',[_c('span',{staticClass:"status-",class:'status-'+_vm.object.status},[_vm._v(_vm._s(_vm.object.status_name))])])])]),_vm._v(" "),_c('a',{staticClass:"btn btn-link",attrs:{"href":_vm.object.resource_urls.pdf,"target":"_pdf"}},[_c('span',{staticClass:"icon icon-pdf"}),_vm._v("Bofaktablad")]),_vm._v(" "),_c('div',{staticClass:"object-info-footer"},[_c('router-link',{staticClass:"btn btn-link",attrs:{"to":".."}},[_c('span',{staticClass:"icon icon-arrow-left"}),_vm._v(" Tillbaka")])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "r8F1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slider_component__ = __webpack_require__("GDE4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__functions__ = __webpack_require__("ljCr");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SunstudyControls',
  props: ['sunstudy', 'view', 'slide'],
  data: function data() {
    return {
      currentFrame: null,
      fakeSliderLeftWidth: 10,
      fakeSliderRightWidth: 10
    };
  },

  watch: {
    currentFrame: function currentFrame() {
      this.$emit('slide', this.currentFrame);
    },
    view: function view() {
      this.init();
    }
  },
  created: function created() {
    this.init();
  },

  computed: {
    offsetLeft: function offsetLeft() {
      return this.view.start_hour - 1;
    },
    offsetRight: function offsetRight() {
      return 24 - this.view.end_hour;
    },
    step: function step() {
      var hours = this.view.end_hour - this.view.start_hour;
      return this.view.image_count / hours;
    },
    currentHour: function currentHour() {
      return Math.round(this.currentFrame / this.step) + this.view.start_hour;
    },
    cols: function cols() {
      var cols = [];
      for (var i = 1; i <= 24; i++) {
        cols.push({
          key: i,
          time: i,
          className: i < this.view.start_hour || i > this.view.end_hour ? 'time-col disabled' : 'time-col',
          label: Object(__WEBPACK_IMPORTED_MODULE_1__functions__["a" /* pad */])('00', i, true)
        });
      }
      return cols;
    }
  },
  methods: {
    onHourClick: function onHourClick(hour) {
      var slide = Math.round(hour.time * this.step);
      this.$emit('slide', slide);
    },
    init: function init() {
      var _this = this;

      this.currentFrame = this.view.start_frame;
      if (this.$refs['slider']) {
        this.$nextTick(function () {
          _this.$refs['slider'].refresh();
        });
      }
    },
    changeView: function changeView(view) {
      this.$emit('view', view);
    }
  },
  components: {
    vueSlider: __WEBPACK_IMPORTED_MODULE_0_vue_slider_component___default.a
  }
});

/***/ }),

/***/ "x8l5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ObjectList_vue__ = __webpack_require__("+k2G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21fc2bbd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ObjectList_vue__ = __webpack_require__("Y59b");
function injectStyle (ssrContext) {
  __webpack_require__("1PIj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-21fc2bbd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ObjectList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21fc2bbd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ObjectList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "zgV5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Start_vue__ = __webpack_require__("hcza");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4996c20a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Start_vue__ = __webpack_require__("QBU0");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Start_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4996c20a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Start_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.8dc1baa3ff4ccf325fc3.js